module.exports = __webpack_public_path__ + "images/feature/time-tracking-f5de60730d31637996132619ee91c84a.png";